export class ChartData {
  data: number[] | undefined;
  label: string | undefined;
  maxBarThickness: number = 80 ;
}
